import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import Navbar from "./pages/Navbar/Navbar";
import MainRoutes from "./pages/Route/route";
import Footer from "./pages/Footer/Footer";
import "../src/App.css";
import Loader from "./Components/Loader/Loader";
import { CartProvider } from "./context/CartContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <CartProvider>
      <BrowserRouter>
        <Navbar />
        <ToastContainer position="top-right" autoClose={5000} />
        <MainRoutes />
        {/* <Footer /> */}
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
